import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { styled } from '@mui/system';
import {
  AppBar,
  Badge,
  Box,
  IconButton,
  Toolbar,
  Tooltip,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { LogoSVG } from '../../../../assets/svg/index';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import _ from 'lodash';

import './navbar.scss'
import { useGetProjectLazyQuery } from '../../../../../graphql/generated/graphql';
import { useLoginState } from '../../../../hooks/loginInfo';
import { UserTypes } from '../../../../config/enums';

const DashboardNavbarRoot = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  [theme.breakpoints.down('md')]: {
    backgroundColor: '#000',
  },
}));

interface TranslateMenuOptions {
  'creative-docs': 'Creative Docs',
  'contacts': 'Project Contacts',
  'calendar': 'Calendar',
  'locations': 'Locations',
  'call-sheet': 'Call Sheet',
  'person': 'Person Settings',
  'company': 'Company Settings',
  'notes': 'Notes',
  'call-sheet/new': 'New Callsheet',
  'call-sheet/edit': 'Edit Callsheet',
  '/project/new': 'New Project',
  '/project/edit': 'Edit Project',
  'projectDetails': 'Project Details'
}

const translateMenuOptions: TranslateMenuOptions = {
  'creative-docs': 'Creative Docs',
  'contacts': 'Project Contacts',
  'calendar': 'Calendar',
  'locations': 'Locations',
  'call-sheet': 'Call Sheet',
  'person': 'Person Settings',
  'company': 'Company Settings',
  'notes': 'Notes',
  'call-sheet/new': 'New Callsheet',
  'call-sheet/edit': 'Edit Callsheet',
  '/project/new': 'New Project',
  '/project/edit': 'Edit Project',
  'projectDetails': 'Project Details'

}

const DashboardNavbar = (props: any) => {
  const { onSidebarOpen, ...other } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const [route, setRoute] = useState('')
  const loginState = useLoginState();
  const userType = loginState.user_type.get();

  const projectId = !_.isEmpty(params)
    ? params['type']
      ? ''
      : params["projectId"]
    : '';

  const [projectInfo, { data: project }] = useGetProjectLazyQuery({
    variables: {
      project_id: '',
    },
  });

  useEffect(() => {
    // save info project
    if (!_.isEmpty(params)) {
      if (!params['type']) {
        projectInfo({
          variables: {
            project_id: projectId as string
          }
        })
      }
    }
  }, [])

  useEffect(() => {
    if (location) {
      // know if you are creating a new project
      if (location.pathname.includes('/project/new')) {
        setRoute(translateMenuOptions['/project/new' as keyof TranslateMenuOptions])
      }
      // know if you are editing a project
      if (location.pathname.includes('/project/edit')) {
        setRoute(translateMenuOptions['/project/edit' as keyof TranslateMenuOptions])
        return
      }
      //if the view has params
      if (!_.isEmpty(params)) {
        //knows if you are editing call sheet
        if (params['*']?.includes('call-sheet/edit')) {
          setRoute(translateMenuOptions['call-sheet/edit' as keyof TranslateMenuOptions])
        }
        //knows if you are confirming call sheet
        else if (params['*']?.includes('call-sheet/confirm/')) {
          setRoute(translateMenuOptions['call-sheet' as keyof TranslateMenuOptions])
        }
        //know if your are in other view
        else {
          setRoute(translateMenuOptions[params["*"] as keyof TranslateMenuOptions])
        }
      }
    }
  }, [params, location])

  return (
    <>
      <DashboardNavbarRoot
        sx={{
          left: {
            lg: 280,
          },
          width: {
            lg: 'calc(100% - 280px)',
          },
        }}
        {...other}
      >
        <Toolbar
          disableGutters
          sx={{
            height: 64,
            left: 0,
            px: 2,
          }}
        >
          <IconButton
            onClick={onSidebarOpen}
            sx={{
              display: {
                xs: 'inline-flex',
                lg: 'none',
              },
            }}
          >
            <MenuIcon color="primary" fontSize="small" />
          </IconButton>
          <Tooltip
            onClick={() => {
              navigate('/');
            }}
            title="Logo"
          >
            <IconButton
              sx={{
                width: '200px',
                maxWidth: '50%',
                height: 'auto',
                display: {
                  xs: 'inline-flex',
                  lg: 'none',
                },
              }}
            >
              <LogoSVG />
            </IconButton>
          </Tooltip>
          <Box className='container-route'>
            <IconButton
              onClick={() => {
                navigate('/');
              }}
            >
              <HomeOutlinedIcon className='black-color-icon' />
            </IconButton>
            <p style={{
              fontSize: '14px',
              fontWeight: '500'
            }}>
              {
                userType === UserTypes.PRODUCER &&
                <>
                  <span className='mr-10'>{`>`}</span>
                  <span className='mr-10'>Producer</span>
                </>
              }
              {
                userType === UserTypes.CREW_MEMBER &&
                <>
                  <span className='mr-10'>{`>`}</span>
                  <span className='mr-10'>Crew member</span>
                </>
              }
              {_.isEmpty(params) && route === 'New Project' &&
                <>
                  <span className='mr-10'>{'>'}</span>
                  <span className='mr-10'>{route}</span>

                </>
              }
              {!_.isEmpty(params) && route === 'Edit Project' &&
                <>
                  <span className='mr-10'>{'>'}</span>
                  <span className='mr-10'>{route}</span>
                  <span className='mr-10'>{'>'}</span>
                  <span className='mr-10'>{project?.getProject?.project_name}</span>
                </>
              }
              {!_.isEmpty(params) && route !== 'Edit Project' &&
                <>
                  <span className='mr-10'>{'>'}</span>
                  <span className='mr-10'>{params['*'] ? project?.getProject?.project_name : translateMenuOptions[params["type"] as keyof TranslateMenuOptions]}</span>
                  {params["*"] &&
                    <>
                      <span className='mr-10'>{'>'}</span>
                      <span>
                        {route}
                      </span>
                    </>
                  }
                </>
              }
            </p>
          </Box>
          <Box flexGrow={1}>
          </Box>
        </Toolbar>
      </DashboardNavbarRoot>
    </>
  );
};

export default DashboardNavbar;
